import React from 'react';

const traces = [
  { name: 'Normal', path: 'M0 38 L35 38 L42 35 L49 38 L67 38 L72 44 L78 11 L84 49 L91 38 L110 38 Q123 21 138 38 L180 38', note: 'Linha de base estável após o complexo QRS.' },
  { name: 'Repolarização inespecífica', path: 'M0 38 L35 38 L42 35 L49 38 L67 38 L72 44 L78 11 L84 49 L91 41 L108 44 Q123 51 140 40 L180 38', note: 'Mudanças de repolarização sem desvio significativo do ST.' },
  { name: 'Desvio significativo do ST', path: 'M0 38 L35 38 L42 35 L49 38 L67 38 L72 44 L78 11 L84 49 L91 24 L115 24 Q130 19 143 38 L180 38', note: 'Observe o segmento ST deslocado em relação à linha de base.' }
];

export default function EcgExplorer({ value, onChange }) {
  return (
    <fieldset className="field">
      <legend className="field-title">Explorador de ECG <span className="optional">0–2 pontos</span></legend>
      <p className="field-note">Traçados esquemáticos para aprendizado; não representam um ECG diagnóstico.</p>
      <div className="ecg-grid">
        {traces.map((trace, index) => (
          <label key={trace.name} className={`ecg-card ${value === index ? 'selected' : ''}`}>
            <input type="radio" name="ecg" checked={value === index} onChange={() => onChange(index)} />
            <svg viewBox="0 0 180 65" role="img" aria-label={`Traçado esquemático: ${trace.name}`}>
              <path d="M0 38 H180 M0 18 H180 M0 58 H180" className="ecg-gridline" />
              <path d={trace.path} className="ecg-line" />
            </svg>
            <strong>{trace.name} · {index} pt</strong>
            <small>{trace.note}</small>
          </label>
        ))}
      </div>
      <p className="field-note">Alterações inespecíficas incluem bloqueio de ramo esquerdo, hipertrofia ventricular esquerda, marca-passo ou efeito de digoxina. A classificação deve considerar o ECG real.</p>
    </fieldset>
  );
}
